import React from "react";
import styles from "./Slidetab.module.scss";

export const SlideTabs = ({ slides, activeSlide, onSlideChange, disabled }) => {
  return (
    <div className={styles.sliderowdisplay} disabled={disabled} style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}>
      {slides.map((slide) => (
        <span
          key={slide.id}
          style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}
          className={`${styles.slideTab} ${activeSlide === slide.id ? styles.activeTab : ""}`}
          onClick={() => !disabled && onSlideChange(slide.id)}
        >
          {slide.name}
        </span>
      ))}
    </div>
  );
};


export const SlideTabsControl = ({ 
  slides, 
  activeSlide, 
  onSlideChange,
  singleTabMode = false,
  currentModule,
  multipleModuleData = []
}) => {
  
  // Filter slides based on module sourceCombination for multi-module creation
  const getFilteredSlides = () => {
    if (singleTabMode) {
      return slides.filter(slide => slide.id === activeSlide);
    }
    
    // For multi-module creation, filter by current module's sourceCombination
    if (multipleModuleData.length > 0 && currentModule) {
      const currentModuleData = multipleModuleData[currentModule - 1];
      if (currentModuleData?.sourceCombination) {
        return slides.filter(slide => 
          currentModuleData.sourceCombination.includes(slide.id)
        );
      }
    }
    
    // Default: show all slides
    return slides;
  };

  const displaySlides = getFilteredSlides();

  // If no slides after filtering, show a message
  if (displaySlides.length === 0) {
    return (
      <div className={styles.sliderowdisplay}>
        <span className={styles.noSlidesMessage}>
          No slides available for this module
        </span>
      </div>
    );
  }

  return (
    <div className={styles.sliderowdisplay}>
      {displaySlides.map((slide) => (
        <span
          key={slide.id}
          className={`${styles.slideTab} ${activeSlide === slide.id ? styles.activeTab : ""}`}
          onClick={() => onSlideChange(slide.id)}
        >
          {slide.name}
        </span>
      ))}
    </div>
  );
};
